// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"216":"map-search","1418":"map-tour"}[chunkId] || chunkId) + "." + {"216":"32fd66f9","1418":"32fd66f9","6805":"e3086cbf","8295":"08b47904"}[chunkId] + ".chunk.css";
};